import { HttpErrorResponse, HttpEvent, HttpEventType, HttpHandler, HttpInterceptor, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { Observable, from, switchMap, catchError, tap, throwError } from 'rxjs';
import { UtilityFunctions } from '../shared/helpers/utility-functions';
import { Injectable } from '@angular/core';
import { KeycloakService } from 'keycloak-angular';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(private keycloakService: KeycloakService) { }

  intercept(req: HttpRequest<any>, next: HttpHandler) : Observable<HttpEvent<any>> {

    if (this.keycloakService.isTokenExpired())
    {
      this.keycloakService.login();
    }
    
    return from(this.keycloakService.updateToken(100)).pipe(
      // Once token is updated, get the token
      switchMap(() => {
        // Get the refreshed token
        return from(this.keycloakService.getToken()).pipe(
          switchMap((token) => {
            // Store the updated token in sessionStorage
            sessionStorage.setItem('token', token);

            // Clone the request with the updated Authorization header
            const authReq = req.clone({
              headers: req.headers.set('Authorization', `Bearer ${token}`)
            });

            // Forward the request with the updated token
            return next.handle(authReq);
          })
        );
      }),
      catchError((err: any) => {
        // Handle error for token refresh failure
        if (err instanceof HttpErrorResponse) {
          if (err.status === 401 || err.status === 403) {
            UtilityFunctions.showMessage('Unauthorised request, please contact the administrator.', 'error',4000);
          }
          console.log(err);
        }

        // If token update fails, trigger a re-login
        if (this.keycloakService.isTokenExpired()) {
          this.keycloakService.login();
        }
        return throwError(() => err);
      })
    );
  }


}
